import { useEffect, useState } from "react";
import type { PublicBranding } from "@probetalab/contracts";
import { get, urlFor } from "./api.js";

/**
 * Who this host belongs to, before anyone signs in (ADR 0025): `GET /v1/public/branding`. On a
 * laboratory's own host (`sonder.probetalab.com`, `sistema.laboratoriosonder.com`) the server names
 * the laboratory; on the platform host (`app.probetalab.com`) it names nobody. Loaded once per page
 * load and kept for the tab title and the login screen; a network failure is simply "unknown".
 */

let cached: PublicBranding | null = null;
let pending: Promise<PublicBranding | null> | null = null;

/** The branding already loaded, or null. */
export function siteBranding(): PublicBranding | null {
  return cached;
}

export function loadSiteBranding(): Promise<PublicBranding | null> {
  pending ??= get("publicBranding")
    .then((b) => (cached = b))
    .catch(() => null);
  return pending;
}

/** The host's laboratory logo (no session needed). */
export function publicLogoUrl(): string {
  return urlFor("publicLogo");
}

export function useSiteBranding(): PublicBranding | null {
  const [site, setSite] = useState<PublicBranding | null>(cached);
  useEffect(() => {
    let live = true;
    void loadSiteBranding().then((b) => {
      if (live) setSite(b);
    });
    return () => {
      live = false;
    };
  }, []);
  return site;
}

/** Tests only: forget the loaded branding. */
export function resetSiteBranding(value: PublicBranding | null = null): void {
  cached = value;
  pending = value ? Promise.resolve(value) : null;
}
